<template>
    <div class="pay-setting-wrapper">
        <slide-container v-if="visible"
            :isLoading="isLoading"
            v-bind="$attrs"
            v-on="$listeners"
            :width="'400px'"
            :headerTitle="'支付方式设置'"
            :isShowFooter="false"
            @close="$emit('update:visible', false)">
            <p class="header-title">系统默认</p>
            <div class="mt-12 pay-types">
                <div v-for="item in defaultPayTypes"
                    class="pay-types__item h-44 pl-12 pr-12 fx-v-center fx-h-between"
                    :key="item.id">
                    <div class="pay-types__item-left fx-v-center">
                        <img class="mr-12" :src="item.logo" alt="logo">
                        <span>{{ item.name }}</span>
                        <question-icon v-if="item.tips"
                            class="ml-6"
                            :popperWidth="313"
                            :placement="'top'">
                            <p class="lh-18 fs-12">{{ item.tips }}</p>
                        </question-icon>
                    </div>
                    <el-switch v-model="item.isChecked"
                        active-color="#009688"
                        inactive-color="#ddd"
                        @change="switchChange(item, $event)" />
                </div>
            </div>
            <p class="header-title mt-20">自定义</p>
            <div class="mt-12 pay-types">
                <div v-for="item in otherPayTypes"
                    class="pay-types__item h-44 pl-12 pr-12 fx-v-center fx-h-between"
                    :key="item.id">
                    <div class="pay-types__item-left fx-v-center">
                        <img class="mr-12" :src="item.logo" alt="logo">
                        <span>{{ item.name }}</span>
                    </div>
                    <div class="pay-types__item-right fx-v-center">
                        <el-switch v-model="item.isChecked"
                            class="mr-12"
                            active-color="#009688"
                            inactive-color="#ddd"
                            @change="customSwitchChange(item, $event)" />
                        <el-popover placement="bottom"
                            width="80"
                            popper-class="__edit-payment-type__"
                            trigger="click">
                            <div class="popover-item" @click="editPay('update', item)">编辑</div>
                            <i class="el-icon-more" slot="reference" />
                        </el-popover>
                    </div>
                </div>
                <div v-if="otherPayTypes.length < 3" class="pay-types__item h-44 pl-12 pr-12 fx-v-center">
                    <span class="href" @click="editPay('create')">+新增支付方式</span>
                </div>
            </div>
        </slide-container>
        <!-- components -->
        <add-edit-pay-setting :visible.sync="isShowAddEditPaySetting"
            :mode="dialodMode"
            :customPaymentconfigId="customPaymentconfigId"
            :canDelete="isThisCanDel"
            @success="editSuccess" />
    </div>
</template>

<script lang="ts">
import { createComponent, ref, watch, onBeforeMount, onMounted, reactive } from '@vue/composition-api'
import SlideContainer from '@/components/layout/side-container-style2.vue'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import AddEditPaySetting from './add_edit_pay_setting.vue'
import { openMessage } from '../../../utils/system'
import $fetch from '../../../api'

interface IDefaultPayType {
    id: number
    key: number
    name: string
    logo: string
    isChecked: boolean
    tips?: string
}

interface IOtherPayType {
    id: number
    name: string
    logo: string,
    canDelete: boolean,
    isChecked: boolean
}

export default createComponent({
    props: {
        visible: Boolean,
    },

    setup: (props, ctx) => {
        const isLoading = ref(false)
        const isShowAddEditPaySetting = ref(false)
        const isThisCanDel = ref(true)
        const customPaymentconfigId = ref(-1)
        const dialodMode = ref<'create' | 'update'>('create')
        const defaultPayTypes = reactive<IDefaultPayType[]>([{
            id: 0,
            key: 0,
            name: '现金',
            logo: require('../images/cashi.svg'),
            isChecked: true
        }, {
            id: 1,
            key: 1,
            name: '条码收款',
            logo: require('../images/barcode.svg'),
            tips: '对接后可使用扫码枪或者手机，扫描客户的支付宝/微信付款码快速收款。',
            isChecked: true
        }, {
            id: 2,
            key: 4,
            name: '银行卡',
            logo: require('../images/blank.svg'),
            isChecked: true
        }, {
            id: 3,
            key: 2,
            name: '个人支付宝',
            logo: require('../images/alipay.svg'),
            isChecked: true
        }, {
            id: 4,
            key: 3,
            name: '个人微信',
            logo: require('../images/wechat.svg'),
            isChecked: true
        }])

        const otherPayTypes = ref<IOtherPayType[]>([])

        const paymentType = {
            0: '条码收款',
            1: '现金',
            2: '个人支付宝',
            3: '个人微信',
            4: '银行卡'
        }

        watch(() => props.visible, (newVal) => {
            if (newVal) {
                getPaySettingWithLoading()
            }
        })

        async function getPaySetting() {
            try {
                const result = await $fetch.post({
                    url: '/shop/getshoppayment'
                })
                console.log('支付方式', result)
                defaultPayTypes.forEach(item => {
                    if (result.paymentconfig.payment_list.includes(item.key)) {
                        item.isChecked = true
                    } else {
                        item.isChecked = false
                    }
                })
                otherPayTypes.value = result.custom_payment_config.filter(item => item.status !== -1).map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        logo: require('../images/other.svg'),
                        canDelete: item.can_delete,
                        isChecked: item.status === 1
                    }
                })
            } catch (e) {
                openMessage('error', e.message || '获取支付方式信息失败')
            }
        }

        // 1: 正常      0: 禁用
        async function editPaymentConfig(payment: number, status: 1 | 0) {
            try {
                await $fetch.post({
                    url: '/shop/editpaymentconfig',
                    params: {
                        payment,
                        status
                    }
                })
                openMessage('success', '设置成功')
                ctx.emit('success')
            } catch (e) {
                getPaySettingWithLoading()
                openMessage('error', e.message || '编辑失败')
            }
        }

        // 1: 正常      0: 禁用
        async function editCustomPaymentConfig(custom_paymentconfig_id: number, status: 1 | 0) {
            try {
                await $fetch.post({
                    url: '/shop/editcustompaymentconfig',
                    params: {
                        custom_paymentconfig_id,
                        status
                    }
                })
                openMessage('success', '设置成功')
                ctx.emit('success')
            } catch (e) {
                getPaySettingWithLoading()
                openMessage('error', e.message || '编辑失败')
            }
        }

        function switchChange(item: IDefaultPayType, newVal: boolean) {
            if (!isCanSwitch()) {
                item.isChecked = !item.isChecked
                return openMessage('error', '至少保留一种支付方式')
            }
            editPaymentConfig(item.key, newVal ? 1 : 0)
        }

        function customSwitchChange(item: IOtherPayType, newVal: boolean) {
            if (!isCanSwitch()) {
                item.isChecked = !item.isChecked
                return openMessage('error', '至少保留一种支付方式')
            }
            editCustomPaymentConfig(item.id, newVal ? 1 : 0)
        }

        function isCanSwitch() {
            const flagOne = defaultPayTypes.some(item => item.isChecked)
            const flagTwo = otherPayTypes.value.some(item => item.isChecked)
            return flagOne || flagTwo
        }

        function getPaySettingWithLoading() {
            isLoading.value = true
            getPaySetting()
                .then(() => isLoading.value = false)
        }

        function editPay(mode: 'create' | 'update', item?: IOtherPayType) {
            if (item) {
                customPaymentconfigId.value = item.id
                isThisCanDel.value = item.canDelete
            }
            dialodMode.value = mode
            isShowAddEditPaySetting.value = true
        }

        function editSuccess() {
            ctx.emit('success')
            getPaySettingWithLoading()
        }

        return {
            isLoading,
            isShowAddEditPaySetting,
            isThisCanDel,
            customPaymentconfigId,
            dialodMode,
            defaultPayTypes,
            otherPayTypes,
            editPay,
            getPaySettingWithLoading,
            switchChange,
            customSwitchChange,
            editSuccess
        }
    },

    components: {
        SlideContainer,
        QuestionIcon,
        AddEditPaySetting
    }
})
</script>

<style lang="scss">
.__edit-payment-type__ {
    min-width: auto !important;
    padding: 8px 0 !important;

    .popover-item {
        height: 34px;
        line-height: 34px;
        padding: 0 12px;
        cursor: pointer;

        &:hover {
            background-color: #f7f7f7;
        }
    }
}
</style>

<style lang="scss" scoped>
::v-deep main {
    padding: 20px 12px;

    .header-title {
        margin-left: 8px;
    }

    .h-44 {
        height: 44px;
    }

    .mw-80 {
        min-width: 80px;
    }

    .pay-types {
        &__item {
            border: 1px solid #ebebeb;
            border-bottom: none;

            &:last-child {
                border-bottom: 1px solid #ebebeb;
            }

            &:hover {
                background-color: #f7f7f7;
            }

            img {
                width: 20px;
                height: 20px;
                border-radius: 50%;
            }

            .el-icon-more {
                transform: rotate(90deg);
                color: #888;
                cursor: pointer;
            }
        }
    }
}
</style>
